import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && (
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm text-foreground-700" />
            </span>
          )}
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-300">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-300">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export type { Crumb };